import React, { ReactNode, useEffect, useState } from 'react';
import css from './Widget.module.css';
import { Paragraph } from '../text';

enum WidgetState {
  Loading,
  Ready,
}

export interface WidgetProps {
  isLoading?: boolean;
  loadingMessage?: string;
  children: ReactNode;
}

const WidgetBase: React.FC<WidgetProps> = (props: WidgetProps) => {
  const [currentState, setCurrentState] = useState<WidgetState>(
    props.isLoading ? WidgetState.Loading : WidgetState.Ready
  );

  /* Update state for isLoading prop changes */
  useEffect(() => {
    if (props.isLoading) {
      setCurrentState(WidgetState.Loading);
    } else if (currentState === WidgetState.Loading) {
      setCurrentState(WidgetState.Ready);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isLoading]);

  return (
    <div className={css.mainContent}>
      {(() => {
        switch (currentState) {
          case WidgetState.Loading:
            return <Paragraph text={props.loadingMessage ?? 'Loading...'} />;
          case WidgetState.Ready:
            return <>{props.children}</>;
          default:
            return null;
        }
      })()}
    </div>
  );
};

const Widget: React.FC<WidgetProps> = (props: WidgetProps) => {
  return <WidgetBase {...props} />;
};

export default Widget;
